// Routes config file

import DashboardPage from "@/Pages/DashboardPage";
import ForgotPasswordPage from "@/Pages/ForgotPasswordPage";
import LoginPage from "@/Pages/LoginPage";
import NewClaimPage from "@/Pages/NewClaimPage";
import ResetPasswordPage from "@/Pages/ResetPasswordPage";
import ReportsPage from "@/Pages/ReportsPage";
import TermsConditionsPage from "@/Pages/TermsConditionsPage";
import AboutUsPage from "@/Pages/AboutUsPage";
import CookiesPage from "@/Pages/CookiesPage";
import PrivacyPolicyPage from "@/Pages/PrivacyPolicyPage";
import DsarRequest from "@/Pages/DsarRequestPage";
import UsersPage from "@/Pages/Users/UsersPage";
import CreateUserPage from "@/Pages/Users/CreateUserPage";
import UserPage from "@/Pages/Users/UserPage";
import AuditsPage from "@/Pages/Audits/AuditsPage";
import CreateTeamPage from "@/Pages/Teams/CreateTeamPage";
import TeamsPage from "@/Pages/Teams/TeamsPage";
import TeamPage from "@/Pages/Teams/TeamPage";
import ClientsPage from "@/Pages/Clients/ClientsPage";
import CreateClientPage from "@/Pages/Clients/CreateClientPage";
import ClientPage from "@/Pages/Clients/ClientPage";
import OrgUnavailablePage from "@/Pages/OrgUnavailablePage";
import InactivePermissionsPage from "@/Pages/InactivePermissionsPage";
import MyProfilePage from "@/Pages/MyProfilePage";
import GtaRatesPage from "@/Pages/GtaRates/GtaRatesPage";
import GtaRatePage from "@/Pages/GtaRates/GtaRatePage";
import CreateGtaRatePage from "@/Pages/GtaRates/CreateGtaRatePage";
import SettingsPage from "@/Pages/General/SettingsPage";

export const routes = {
    'private': [
        {
            name: 'home',
            path: '/',
            component: <DashboardPage/>
        },
        {
            name: 'new-claim',
            path: '/new-claim',
            component: <NewClaimPage/>
        },
        {
            name: 'my-profile',
            path: '/my-profile',
            key: 'my-profile',
            component: <MyProfilePage/>
        },
        {
            name: 'reports',
            path: '/reports',
            component: <ReportsPage/>
        },
        {
            name: 'create-team',
            path: '/create-team',
            component: <CreateTeamPage/>
        },
        {
            name: 'teams',
            path: '/teams',
            component: <TeamsPage/>
        },
        {
            name: 'team',
            path: '/teams/:teamId',
            component: <TeamPage/>
        },
        {
            name: 'create-user',
            path: '/create-user',
            component: <CreateUserPage/>
        },
        {
            name: 'users',
            path: '/users',
            component: <UsersPage/>
        },
        {
            name: 'user',
            path: '/users/:userId',
            key: 'user',
            component: <UserPage/>
        },
        {
            name: 'gta-rates',
            path: '/gta-rates',
            component: <GtaRatesPage/>
        },
        {
            name: 'gta-rate',
            path: '/gta-rates/:gtaRateId',
            key: 'gta-rate',
            component: <GtaRatePage/>
        },
        {
            name: 'create-gta-rate',
            path: '/create-gta-rate',
            component: <CreateGtaRatePage/>
        },
        {
            name: 'audits',
            path: '/audits',
            component: <AuditsPage/>
        },
        {
            name: 'clients',
            path: '/clients',
            key: 'clients',
            component: <ClientsPage/>
        },
        {
            name: 'client',
            path: '/clients/:clientId',
            key: 'client',
            component: <ClientPage/>
        },
        {
            name: 'create-client',
            path: '/create-client',
            component: <CreateClientPage/>
        },
        {
            name: 'dsar-request',
            path: '/dsar-request',
            component: <DsarRequest/>
        },
        {
            name: 'settings',
            path: '/settings',
            component: <SettingsPage/>
        },
        {
            name: 'terms-of-use',
            path: '/terms-of-use',
            component: <TermsConditionsPage/>
        },
        {
            name: 'about-us',
            path: '/about-us',
            component: <AboutUsPage/>
        },
        {
            name: 'cookies',
            path: '/cookies',
            component: <CookiesPage/>
        },
        {
            name: 'privacy-policy',
            path: '/privacy-policy',
            component: <PrivacyPolicyPage/>
        },
        {
            name: 'org-unavailable',
            path: '/org-unavailable',
            component: <OrgUnavailablePage/>
        },
        {
            name: 'inactive-permissions',
            path: '/inactive-permissions',
            component: <InactivePermissionsPage/>
        }
    ],
    'public': [
        {
            name: 'home',
            path: '/',
            component: <LoginPage/>
        },
        {
            name: 'forgot-password',
            path: '/forgot-password',
            component: <ForgotPasswordPage/>
        },
        {
            name: 'reset-password',
            path: '/reset-password/:code',
            component: <ResetPasswordPage/>
        },
        {
            name: 'terms-of-use',
            path: '/terms-of-use',
            component: <TermsConditionsPage/>
        },
        {
            name: 'about-us',
            path: '/about-us',
            component: <AboutUsPage/>
        },
        {
            name: 'cookies',
            path: '/cookies',
            component: <CookiesPage/>
        },
        {
            name: 'privacy-policy',
            path: '/privacy-policy',
            component: <PrivacyPolicyPage/>
        }
    ]
};
